import { http } from "@canvas/api";

export interface SwatchInventoryCreateReq {
  endpoint: "ragnarok.swatch.v1.inventory.create";
  body: {
    inventory: SwatchInventoryRequestBody[];
  };
}

export interface SwatchInventoryRequestBody {
  ec_id: number;
  sku_code: string;
  name: string;
  unique_code: string;
  remarks: string;
  floor: string;
  product_code: string;
  brand: string;
}

export interface SwatchInventoryCreateRes {}

export function post(
  req: SwatchInventoryCreateReq
): Promise<SwatchInventoryCreateRes> {
  return http
    .POST(`/ragnarok/swatch/v1/inventory`, JSON.stringify(req.body))
    .then((response: SwatchInventoryCreateRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
